export interface IOperationResult {
    message: string;
}